import React from 'react';
import { FlexColumn } from '@make-software/tg-mini-app-ui';
import Lottie from 'lottie-react';

import { CommonDescription, TitleRow } from '@/shared';
import loadingAnimation from '@/shared/assets/lottie/loading-animation.json';

interface IApiStateProps {
  title: string;
  description?: string;
}

export const LoadingState = () => (
  <FlexColumn>
    <FlexColumn justify="center" align="center" style={{ alignSelf: 'center' }}>
      <Lottie animationData={loadingAnimation} style={{ height: 220, width: 220 }} loop />
    </FlexColumn>
  </FlexColumn>
);

export const ErrorState: React.FC<IApiStateProps> = ({ title }) => (
  <FlexColumn>
    <TitleRow weight={1} color="#FFFFFF" size="lg" margin="0 0 8px 0">
      {title}
    </TitleRow>
    <CommonDescription>Please try again later.</CommonDescription>
  </FlexColumn>
);

export const NotFoundState: React.FC<Pick<IApiStateProps, 'title'>> = ({ title }) => (
  <FlexColumn>
    <TitleRow weight={1} color="#FFFFFF" size="lg" margin="0 0 8px 0">
      {title}
    </TitleRow>
  </FlexColumn>
);
